import { useEffect } from 'react';
import { Button, Col, DatePicker, Form, Modal, Row, Switch } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import { useRef } from 'react';
import { useState } from 'react';
import { useAddChildActivityMutation, useUploadChildPhotoMutation } from '@/services/child-api';

const UploadModal = ({ childId, referral, open, refetch, onClose }) => {
  const [form] = Form.useForm();
  const hiddenFileInput = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadPhoto, { isLoading }] = useUploadChildPhotoMutation();
  const [addChildActivity, { isLoading1 }] = useAddChildActivityMutation();
  const [showInput, setShowInput] = useState(false);
  const [daysBetween, setDaysBetween] = useState(0);

  const handleFileChange = (event) => {
    const file = event.target.files;
    if (file) {
      // Handle the file upload
      // console.log(file);
      setSelectedFile(file);
      // You can then process the file or set it in the state
    }
  };

  useEffect(() => {
    if (open) {
      // setTimeout(() => {
      form.resetFields();
      // });
      hiddenFileInput.current.click();
    }
  }, [open, form]);

  const handleDateChange = (date) => {
    const startDate = form.getFieldValue(['activity', 'start']);
    if (date && date.isAfter(dayjs(startDate))) {
      setShowInput(true);
      const days = dayjs(date).diff(dayjs(startDate), 'day');
      setDaysBetween(days);
    } else {
      setShowInput(false);
    }
  };

  const onFinish = async (values) => {
    let data = values;
    data.activity.start = data.activity.start?.format('YYYY-MM-DD');
    data.activity.end = data.activity.end?.format('YYYY-MM-DD');
    data = { ...data, type: { id: 14620 } };

    const body = new FormData();
    for(var f of selectedFile)
      body.append('file', f);
    try {
      await addChildActivity({ childId, body: data });
      await uploadPhoto({ childId, body }).unwrap();
      refetch();
      onClose();
    } catch (err) {}
  };

  const handleUploadAndSkip = async () => {
    const body = new FormData();
    for(var f of selectedFile)
      body.append('file', f);
    try {
      await uploadPhoto({ childId, body }).unwrap();
      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Photo Upload"
      open={open}
      //   confirmLoading={updating}
      okText="Upload"
      onCancel={onClose}
      footer={null}
    >
      {!isLoading && !isLoading1 && (
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            activity: {
              start: dayjs(referral),
            },
          }}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name={['activity', 'start']} label="Start Date">
                <DatePicker
                  format="MM/DD/YYYY"
                  disabled
                  onBlur={(e) => {
                    const inputVal = e.target.value;
                    const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
                    if (validDate.isValid()) {
                      form.setFieldsValue({
                        activity: { ...form.activity, start: validDate },
                      });
                    } else {
                      form.setFieldsValue({
                        activity: { ...form.activity, start: null },
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name={['activity', 'end']} label="End Date" rules={[{ required: true }]}>
                <DatePicker
                  format="MM/DD/YYYY"
                  onChange={handleDateChange}
                  onBlur={(e) => {
                    const inputVal = e.target.value;
                    const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
                    if (validDate.isValid()) {
                      form.setFieldsValue({
                        activity: { ...form.activity, end: validDate },
                      });
                    } else {
                      form.setFieldsValue({
                        activity: { ...form.activity, end: null },
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>

            {showInput && (
              <>
                <Col span={12}>
                  <Form.Item name="extensionGranted" valuePropName="checked" label="Extension Granted">
                    <Switch />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Days">{daysBetween}</Form.Item>
                </Col>
              </>
            )}
          </Row>
          <input type="file" ref={hiddenFileInput} onChange={handleFileChange} style={{ display: 'none' }} multiple />
          <Row justify="end" gutter={16}>
            <Col>
              <Button key="submit" type="primary" onClick={() => form.submit()}>
                Upload
              </Button>
            </Col>
            <Col>
              <Button key="back" onClick={onClose}>
                Cancel
              </Button>
            </Col>
            <Col>
              <Button key="skip" style={{ color: 'red' }} onClick={handleUploadAndSkip}>
                Upload & Skip Activity
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
};

export default UploadModal;
